import React from 'react';
import Nav from '../components/Nav';
import { database, auth } from '../firebase';
import Skeleton from "react-loading-skeleton";

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.database = database.ref("users")
    this.user = auth.currentUser;
    this.asdf = false;
    this.state = {
      user: [],
      id: "",

      epost: ""
    }
  }

  componentDidMount() {
    auth.onAuthStateChanged(function (user) {
      if (user === null) window.location.pathname = "/giris-yap";
    });

    var bla;
    const user = this.state.user;
    this.database.on('child_added', snap => {
      user.push({
        id: snap.key,
        userName: snap.val().userName,
        userImage: snap.val().userImage,
      });

      user.forEach(u => {
        if (u.id === bla) return;
        else user.splice(user.indexOf(u), 1);
      });

      this.setState({ user: user });
    });

    auth.onAuthStateChanged(user => {
      bla = user.uid;
      var array = [];
      database.ref("users/" + bla).on(`value`, snap => {
        array.push(snap.val());

        this.setState({
          bannerImage: array[0].banner || "/sss-banner.jpg",
          userName: array[0].userName || "Error",
          bio: array[0].bio || "",
          userImage: array[0].userImage || "/default_user.jpg",
          epost: array[0].email,
        });
      });
    });
  }

  yolla() {
    window.location.href = "/profil/duzenle";
  }

  SignOut() {
    auth.signOut().then(function () {
      window.location.href = "/giris-yap";
    }).catch(function (error) { console.log(error) });
  }

  //url(https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Blue_globe_banner.svg/1280px-Blue_globe_banner.svg.png)
  //url(https://i.pinimg.com/originals/0b/a3/d6/0ba3d60362c7e6d256cfc1f37156bad9.jpg)

  //1: https://png.pngtree.com/thumb_back/fh260/background/20190223/ourmid/pngtree-pure-color-watercolor-graffiti-gradient-background-board-design-board-design-image_66713.jpg
  //2: http://www.pngmagic.com/product_images/rain-background-banner-min.jpg
  //3: https://img.wallpapersafari.com/desktop/1024/576/16/8/6oStix.png
  //4: https://validatedlearning.co/wp-content/uploads/2017/08/green-geo-background-banner.jpeg

  render() {
    return (
      <>
        <Nav activeItem="profile" />
        <div className="main">
          <img src="/logout-light.png" className="logout" onClick={this.SignOut} />
          <p style={{ fontSize: "30px", marginBottom: "10px", display: "none" }}>Profil</p>

          <div
            className="banner"
            style={{
              backgroundImage: `url(${this.state.bannerImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          <div className="card">
            <img id="p_photo" src={this.state.userImage} alt="Profil Görseli" className="card-image" />
            <div className="div">
              <h1 id="p_name" style={{ margin: "10px 0" }}>
                {this.state.userName || <Skeleton width={200} style={{ borderRadius: "20px", opacity: ".8" }} />}
              </h1>
              <div id="p_bio" className="card-text">
                {this.state.bio || <Skeleton count={2} className="p_bio-skeleton" />}
              </div>

              <div
                id="p_eposta"
                className="card-date"
                style={auth.currentUser !== null ? { background: "#2f2d33" } : { background: "none" }}
              >
                <div className="tooltip2">
                  <span className="tooltiptext2">Bunu sadece SEN görebilirsin.</span>
                  <div style={{ lineHeight: "0px" }}>
                    <img src="/lock-light.png" style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                  </div>
                </div>
                {this.state.epost}
              </div>
            </div>

            <div className="edit" onClick={this.yolla}>
              <img src="/edit.png" style={{ width: "30px", height: "30px" }} />
              <a style={{ lineHeight: "28px" }}></a>
            </div>
          </div>
        </div>

        <style>{`
        html {
          background: #F57029;
        }
        
        .main {
          width: 100%;
          margin: 0 auto;
          margin-top: 48px;
          padding: 0;
        }

        .banner {
          width: 100%;
          height: 200px;
          margin-bottom: -5px;
          object-fit: cover;
        }

        .card {
          color: #fff;
          border-radius: 3px;
          padding: 25px 0;
          background: #F57029;
          width: max-content;
          margin: 0 auto;
          margin-top: 20px;
          display: flex;
        }

        .card-image {
          position: relative;
          border-radius: 500px;
          width: 40%;
          max-width: 200px;
          height: 200px;
          object-fit: cover;
          background-color: #fff;
        }

        .div {
          padding-left: 15px;
        }

        .card-text {
          min-height: 40px;
          max-width: 500px;
          margin: 0 auto;
          margin-bottom: 30px;
        }

        .p_bio {
          font-size: 20px;
        }

        .p_bio-skeleton {
          width: 500px;
          border-radius: 20px;
          margin-bottom: 10px;
          opacity: .6;
        }

        #p_eposta {
          background: #2f2d33;
          padding: 10px 15px;
          border-radius: 30px;
          margin: auto;
          margin-left: -15px;
          display: flex;
        }
    
        .edit {
          height: max-content;
          padding: 7px;
          z-index: 1;
          border-radius: 30px;
          background: #212121;
          color: #fff;
          outline: none;
          display: flex;
          cursor: pointer;
          transition: .2s;
        }

        .edit:hover {
          background: #5b5b5c;
        }

        .card img {
          width: 150px;
          height: 150px;
          object-fit: cover;
        }

        footer {
          margin: 0;
        }

        .logout {
          position: fixed;
          width: 22px;
          height: 22px;
          background: #2f2d33;
          padding: 12px;
          border-radius: 0 0 10px 0;
          display: none;
        }

        .tooltip2 {
          position: relative;
          display: inline-block;
        }
        
        .tooltip2 .tooltiptext2 {
          visibility: hidden;
          width: 140px;
          background-color: #2f2d33;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          padding-bottom: 10px;
          position: absolute;
          z-index: 1;
          bottom: 32px;
          left: -50px;
          margin-left: -15px;
          opacity: 0;
          box-shadow: 0 0 8px #000;
          transition: opacity 0.3s;
        }
        
        .tooltip2 .tooltiptext2::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #2f2d33 transparent transparent transparent;
        }
        
        .tooltip2:hover .tooltiptext2 {
          visibility: visible;
          opacity: 1;
        }

        @media (max-width: 900px) and (min-width: 623px) {
          .main {
            margin-top: 0px;
          }

          .banner {
            display: block;
          }

          .card {
            width: 100%;
            display: block;
            text-align: center;
          }

          .card-image {
            margin: auto;
            margin-top: -120px;
            border: 8px solid #f57029;
          }

          .div {
            padding: 0;
          }

          .p_bio-skeleton {
            width: 100%;
          }

          #p_eposta {
            width: max-content;
            margin: auto;
          }

          .edit {
            right: 8px;
            bottom: 62px;
            position: fixed;
          }

          .logout {
            display: block;
          }
        }

        @media (max-width: 623px) {
          html {
            background: #F57029;
          }
          
          .main {
            margin-top: 0px;
            padding: 0px 0px;
            box-shadow: 0 0 0;
          }

          .banner {
            height: 150px;
            display: block;
          }

          .card {
            width: 100%;
            padding-bottom: 60px;
            display: block;
            text-align: center;
          }

          .card-image {
            margin: auto;
            width: 280px;
            margin-top: -120px;
            border: 8px solid #f57029;
          }

          .div {
            padding: 0;
          }
          
          .card-text {
            width: 100%;
            max-width: 85%;
            text-align: left;
          }

          .p_bio-skeleton {
            width: 100%;
          }

          #p_eposta {
            max-width: 80%;
            margin: auto;
          }

          .edit {
            right: 8px;
            bottom: 62px;
            position: fixed;
          }

          .logout {
            display: block;
          }
        }
      `}</style>
      </>
    )
  }
};

export default Profile;